import React, { Fragment } from "react";
import { useErrorHandler } from "../../../hooks";
import {
    Button,
    DialogActions,
    DialogContent,
    Divider,
    Grid,
    Paper,
    Table,
    TextField,
    Typography,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Link,
    Dialog,
} from "@material-ui/core";
import DialogTitle from "../../../components/dialog-title";
import FormBuilder from "../../../components/form-builder";
import { dateFormat } from "../../../helpers/date-helpers";
import { useMemo } from "react";
import { currencyFormat, phoneFormat } from "../../../helpers";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import ordersService from "../../../services/orders.service";
import { MOBILE_REG } from "../../../constants/regex";
import useCopyToClipboard from "../../../hooks/useCopyToClipboard";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import CoordinationFormModal from "../../admin/coordination/form"
// import { ImageOutlined as ImageOutlinedIcon } from "@material-ui/icons";
// import { openImage } from "../../../redux/app";
// import { useDispatch } from "react-redux";
// import coordinationService from "../../../services/coordination.service";

function locationTemplate(address, postalCode, location) {
    return (
        `آدرس: ${address}\n` +
        `کد پستی: ${postalCode}\n\n\n` +
        `google: https://www.google.com/maps/search/?api=1&query=${location}\n\n` +
        `waze: https://www.waze.com/ul?ll=${location}\n\n` +
        `apple: https://maps.apple.com/?daddr=${location}`
    );
}

export default function FormModalContent({ close, data }) {
    const {
        id,
        trackingCode,
        status,
        user,
        createDate,
        deliveryDate,
        description,
        totalAmount,
        payableAmount,
        totalDiscount,
        totalInsurance,
        // TODO: show transaction
    } = data;

    const [showFullImg, setShowFullImg] = useState(null)
    const [info, setInfo] = useState();
    const errorHandler = useErrorHandler();
    const { initials } = useSelector((s) => s.app);
    const { account } = useSelector((s) => s.auth);

    const [lensDetail, setLensDetail] = useState(null)

    const initialValues = useMemo(
        () => ({ status, deliveryDate, description }),
        [status, deliveryDate, description]
    );
    const form = useMemo(
        () => [
            {
                _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
                _type: "autocomplete",
                _empty: undefined,
                name: "status",
                options: initials.enums.orderStatus.filter(
                    (i) => !["awaitingPayment"].includes(i.value)
                ),
                valueSelector: "value",
                labelSelector: "title",
                label: "وضعیت",
                disableClearable: true,
            },
            {
                _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
                _type: "datePicker",
                name: "deliveryDate",
                label: "تاریخ ارسال",
                clearable: true,
                time: true,
            },
            {
                _wrapper: (props) => <Grid item xs={12} {...props} />,
                _type: "textField",
                name: "description",
                multiline: true,
                rows: 4,
                label: "توضیحات",
            },
            // { deliveryDate, description },
        ],
        [initials]
    );
    const [phoneNumber, setPhoneNumber] = useState("");
    const [sending, setSending] = useState();
    const copyToClipboard = useCopyToClipboard();

    useEffect(() => {
        if (!account?.phoneNumber) return;
        setPhoneNumber(account.phoneNumber);
    }, [account]);

    useEffect(() => {
        if (!id) return;
        ordersService.getOrder(id).then(({ data, error }) => {
            setInfo(data);
            if (data?.items?.find(it => it.lens)) {
                let lenses = data?.items?.filter(it => it.lens)
            }
        });
    }, [id]);

    const handleSubmit = async (model, { setSubmitting, isSubmitting }) => {
        const { error } = await ordersService.editOrder(id, model);
        setSubmitting(false);
        if (error) return errorHandler(error);
        close(true);
    };

    const validPhoneNumber = useMemo(() => {
        if (!phoneNumber) return;
        return phoneNumber.match(MOBILE_REG);
    }, [phoneNumber]);
    const address = useMemo(() => {
        if (!info) return;
        const { province, city, postalAddress, neighborhood } = info.address;
        return `${province.name}، ${city.name}، ${neighborhood}، ${postalAddress}`;
    }, [info]);

    const sendLocation = async () => {
        if (sending) return;
        setSending(true);
        await ordersService.sendLocation({
            phoneNumber,
            address,
            name: user.fullName,
            location: info.address.location,
            userPhone: user.phoneNumber,
        });
        setSending(false);
    };
    const copyLocation = () => {
        const { location, postalCode } = info.address;
        copyToClipboard(locationTemplate(address, postalCode, location));
    };

    const openLensModal = (id) => {
        const glass = info?.items.find(item => item.id === id);
        if (glass && glass?.userGlassLens?.coordination) {
            setLensDetail(glass);
        }
    }

    const installment = JSON.parse(data?.installmentForm);
    const answersOfInstallment = JSON.parse(data?.answersOfInstallment);
    const installmentForm = installment ? JSON.parse(installment?.form) : []

    return (
        <>

            {showFullImg &&
                <Dialog
                    open
                    maxWidth={"lg"}
                    fullWidth
                >
                    <DialogTitle onClose={() => setShowFullImg(null)}></DialogTitle>
                    <DialogContent>
                        <img src={showFullImg} />
                    </DialogContent>
                </Dialog>
            }
            <DialogTitle onClose={() => close()}>سفارش {trackingCode}</DialogTitle>
            <Divider />
            <DialogContent>
                {user && (
                    <Paper className="mt-2 mb-4 p-2" variant="outlined">
                        <Typography component="h3" variant="h6">
                            مشخصات مشتری
                        </Typography>
                        <Divider className="my-2" />
                        <Grid container spacing={2}>
                            <Grid item sm={6}>
                                <Typography component="span">نام: </Typography>
                                <Typography component="span">{user.fullName}</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography component="span">شماره تماس: </Typography>
                                <Typography component="span" className="en">
                                    {phoneFormat(user.phoneNumber)}
                                </Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography component="span">ایمیل: </Typography>
                                <Typography component="span" className="en">
                                    {user.email}
                                </Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography component="span">تاریخ عضویت: </Typography>
                                <Typography component="span">
                                    {dateFormat(user.createDate)}
                                </Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography component="span">کد ملی: </Typography>
                                <Typography component="span">{user.nationalCode}</Typography>
                            </Grid>

                            {info && (
                                <>
                                    <Grid item xs={12}>
                                        <Divider className="mb-2" />
                                        <Typography component="span">آدرس: </Typography>
                                        <Typography component="span">{address}</Typography>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <Typography component="span">کد پستی: </Typography>
                                        <Typography component="span">
                                            {info.address.postalCode}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <Typography component="span">موقعیت: </Typography>
                                        <Link
                                            target="_blank"
                                            rel="noreferrer"
                                            href={`https://www.google.com/maps/search/?api=1&query=${info.address.location}`}
                                        >
                                            {info.address.location}
                                        </Link>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <TextField
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                            fullWidth
                                            label="شماره تلفن"
                                            type="phone"
                                            className="code-text-field"
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Button
                                            fullWidth
                                            color="primary"
                                            variant="outlined"
                                            onClick={sendLocation}
                                            disabled={!validPhoneNumber || sending}
                                        >
                                            ارسال موقعیت
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Button
                                            fullWidth
                                            color="primary"
                                            variant="contained"
                                            onClick={copyLocation}
                                        >
                                            کپی موقعیت
                                        </Button>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Paper>
                )}
                {
                    installment &&


                    <Paper className="mt-2 mb-4 p-2" variant="outlined">
                        <Typography component="h3" variant="h6">
                            اطلاعات قسط
                        </Typography>
                        <Divider className="my-2" />
                        <Grid container spacing={2}>
                            <Grid item sm={6}>
                                <Typography component="span">عنوان قسط: </Typography>
                                <Typography component="span">{installment.title}</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography component="span">تعداد قسط: </Typography>
                                <Typography component="span">{installment.count}</Typography>
                            </Grid>

                            <Grid item sm={12}>
                                <Divider className="my-2" />
                            </Grid>

                            {
                                installmentForm.map((item, index) => (
                                    <Grid item sm={12}>
                                        <Typography component="span" style={{ width: 'bold' }}>{item.title}: </Typography>
                                        <Typography component="span">{answersOfInstallment?.[item.id]}</Typography>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Paper>
                }

                <Paper className="mt-2 mb-4 p-2" variant="outlined">
                    <div className="d-flex space-between align-center mb-2">
                        <Typography component="h3" variant="h6">
                            سفارش {trackingCode}
                        </Typography>
                        <Typography component="span">{dateFormat(createDate)}</Typography>
                    </div>
                    <Grid container>
                        <Grid item>
                            <Typography>نوع ارسال: {info?.deliveryMethod?.name}</Typography>
                        </Grid>
                    </Grid>
                    <Divider className="my-2" />

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell></TableCell>
                                <TableCell>نوع</TableCell>
                                <TableCell>برند</TableCell>
                                <TableCell>نام</TableCell>
                                <TableCell>رنگ</TableCell>
                                <TableCell>سایز</TableCell>
                                <TableCell>قیمت</TableCell>
                                <TableCell>تخفیف/بیمه</TableCell>
                                <TableCell align="center">تعداد</TableCell>
                                <TableCell align="right">قیمت کل</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {info?.items.map((item, idx) => (
                                <Fragment key={item.id}>
                                    <TableRow>
                                        <TableCell rowSpan={item.lens ? 2 : 1}>{idx + 1}</TableCell>
                                        <TableCell style={{ cursor: 'pointer' }} onClick={() => setShowFullImg(item.frontImage)}>
                                            <img src={item.frontImage} />
                                        </TableCell>
                                        <TableCell>{item.category}</TableCell>
                                        <TableCell>{item.brand}</TableCell>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>{item.color}</TableCell>
                                        <TableCell>{item.size || "-"}</TableCell>
                                        <TableCell>{currencyFormat(item.price)}</TableCell>
                                        <TableCell>
                                            {item.discount ? currencyFormat(item.discount) : "-"}
                                        </TableCell>
                                        <TableCell align="center" rowSpan={item.lens ? 2 : 1}>
                                            {item.count}
                                        </TableCell>
                                        <TableCell align="right" rowSpan={item.lens ? 2 : 1}>
                                            {currencyFormat(
                                                (item.price -
                                                    item.discount +
                                                    (item.lens
                                                        ? item.lens.price - item.lens.insuranceContribution
                                                        : 0)) *
                                                item.count
                                            )}
                                        </TableCell>
                                    </TableRow>
                                    {item.lens && (
                                        <TableRow>
                                            <TableCell>
                                                <div style={{ display: "flex" }}>
                                                    عدسی
                                                    <div style={{ cursor: "pointer" }} onClick={() => openLensModal(item.id)}>
                                                        <InfoOutlined />
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell colSpan={1} />
                                            <TableCell colSpan={3}>{item.lens.name}</TableCell>
                                            <TableCell>{currencyFormat(item.lens.price)}</TableCell>
                                            <TableCell>
                                                {item.lens.insuranceContribution
                                                    ? currencyFormat(item.lens.insuranceContribution)
                                                    : "-"}
                                            </TableCell>
                                            {/* <TableCell colSpan={2} /> */}
                                        </TableRow>
                                    )}
                                </Fragment>
                            ))}
                            <TableRow>
                                <TableCell colSpan={7} className="border-none" />
                                <TableCell colSpan={1} style={{ fontWeight: 700 }}>
                                    جمع کل
                                </TableCell>
                                <TableCell
                                    colSpan={2}
                                    align="right"
                                    style={{ fontWeight: 700 }}
                                >
                                    {currencyFormat(totalAmount)}
                                </TableCell>
                            </TableRow>
                            {Boolean(totalDiscount) && (
                                <TableRow>
                                    <TableCell className="border-none" colSpan={7} />
                                    <TableCell colSpan={1} style={{ fontWeight: 700 }}>
                                        تخفیف
                                    </TableCell>
                                    <TableCell
                                        colSpan={2}
                                        align="right"
                                        style={{ fontWeight: 700 }}
                                    >
                                        {currencyFormat(totalDiscount)}
                                    </TableCell>
                                </TableRow>
                            )}
                            {Boolean(totalInsurance) && (
                                <TableRow>
                                    <TableCell colSpan={7} className="border-none" />
                                    <TableCell colSpan={1} style={{ fontWeight: 700 }}>
                                        سهم بیمه
                                    </TableCell>
                                    <TableCell
                                        colSpan={2}
                                        align="right"
                                        style={{ fontWeight: 700 }}
                                    >
                                        {currencyFormat(totalInsurance)}
                                    </TableCell>
                                </TableRow>
                            )}
                            <TableRow>
                                <TableCell className="border-none" colSpan={7} />
                                <TableCell
                                    className="border-none"
                                    colSpan={1}
                                    style={{ fontWeight: 700 }}
                                >
                                    مبلغ قابل پرداخت
                                </TableCell>
                                <TableCell
                                    className="border-none"
                                    colSpan={2}
                                    align="right"
                                    style={{ fontWeight: 700 }}
                                >
                                    {currencyFormat(payableAmount)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                <FormBuilder
                    // schema={schema}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    form={form}
                    formWrapper={(props) => <Grid container spacing={2} {...props} />}
                    actionComponent={({ isSubmitting }) => (
                        <DialogActions>
                            <Button onClick={close} color="primary" disabled={isSubmitting}>
                                لغو
                            </Button>
                            <Button
                                type="submit"
                                disabled={isSubmitting}
                                variant="contained"
                                color="primary"
                            >
                                تایید
                            </Button>
                        </DialogActions>
                    )}
                />
            </DialogContent>

            {
                lensDetail &&
                <Dialog
                    open={true}
                    fullWidth
                    maxWidth={"md"}
                    classes={{ paper: "matte-glass" }}
                >
                    <CoordinationFormModal
                        close={() => setLensDetail(null)}
                        extra={{
                            lenses: [{
                                ...lensDetail.lens,
                                id: lensDetail.userGlassLens.lensId
                            }]
                        }}
                        data={{
                            ...lensDetail.userGlassLens.coordination,
                            glass: { ...lensDetail },
                            items: [{ ...lensDetail, lensId: lensDetail.userGlassLens.lensId }]

                        }}
                    />
                </Dialog>
            }
        </>
        // </LoadingComponent>
    );
}
